import { render, staticRenderFns } from "./GetRewardLockModal.vue?vue&type=template&id=6ed00e51&scoped=true"
import script from "./GetRewardLockModal.vue?vue&type=script&lang=js"
export * from "./GetRewardLockModal.vue?vue&type=script&lang=js"
import style0 from "./GetRewardLockModal.vue?vue&type=style&index=0&id=6ed00e51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed00e51",
  null
  
)

export default component.exports